<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #STATUS="{ visible, params }">
      <Tracker :statusId="params.row.airway_bill_number" v-if="visible" />
    </template>
  </cTable>
</template>

<script>
import { getCodAbnormal, add, update, del } from "@/api/finance/cod_abnormal";
import { getAllClient } from "@/api/user/client";
import { getStatus } from "@/api/tracker/status";

import cTable from "@/base/common/index";
import Tracker from "@/base/order_tracker";

export default {
  name: "codAbnormal",
  components: {
    cTable,
    Tracker
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "trace_status")
        item.options = (await getStatus()).data.payload.rows;
    });
  },
  data() {
    return {
      methods: {
        list: getCodAbnormal,
        add,
        del,
        update,
        getAllClient
      },
      modals: {
        showStatus: {
          contentSlot: "STATUS",
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              sticky: true
            }
          },
          footer: {
            show: () => false
          }
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              if (row.id) data.id = row.id;
              let type = row.id ? "update" : "add";
              this.$page.handleRequestMethods(type, row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              orders: [
                {
                  required: true,
                  message: "orders cannot be empty",
                  trigger: "blur"
                }
              ],
              types: [
                {
                  required: true,
                  message: "types cannot be empty",
                  trigger: "change"
                }
              ],
              handle_status: [
                {
                  required: true,
                  type: "number",
                  message: "status cannot be empty",
                  trigger: "change"
                }
              ],
              remarks: [
                {
                  required: true,
                  message: "remarks cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { types: 24 },
            { orders: 24 },
            { handle_status: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: () => this.$t("type"),
              key: "types",
              component: "Radio",
              options: [
                {
                  label: this.$t("receivable"),
                  value: "RECEIVE"
                },
                {
                  label: this.$t("bill_close_account_issuing_confirm"),
                  value: "REFUND"
                }
              ],
              bind: {
                border: true
              },
              show() {
                return this.$page.getModal("add").title == this.$t("add")
                  ? true
                  : false;
              }
            },
            {
              name: () => this.$t("exlType"),
              key: "handle_status",
              component: "Radio",
              options: [
                {
                  label: this.$t("refunded"),
                  value: 1
                },
                {
                  label: this.$t("paid_for"),
                  value: 2
                },
                {
                  label: this.$t("finished"),
                  value: 3
                }
              ],
              bind: {
                border: true
              },
              show() {
                return this.$page.getModal("add").title != this.$t("add")
                  ? true
                  : false;
              }
            },
            {
              name: () => this.$t("order_number"),
              key: "orders",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 5
              },
              show() {
                return this.$page.getModal("add").title == this.$t("add")
                  ? true
                  : false;
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [
              { label: this.$t("outboundTime"), value: 1 },
              { label: this.$t("inboundTime"), value: 2 }
            ],
            default: 1
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },

          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            default: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "trace_status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("trajectory");
            },
            clearable: true,
            options: [],
            default: [],
            config: {
              label({ row }) {
                return row.tracker_code + "(" + row.tracker_description + ")";
              },
              value: "tracker_code"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 425
            },

            // {
            //   name: () => this.$t("hang"),
            //   type: "hang",
            //   fnName: "hang",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
            // {
            //   name: () => this.$t("cancel") + this.$t("hang"),
            //   type: "cancelHang",
            //   fnName: "cancelHang",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
              // let data = searchForm;
              // data.export = 1;
              // this.handleRequestMethods("getCod", data).then(res => {
              //   this.$Message["success"]({
              //     background: true,
              //     content: res.msg
              //   });
              //   window.open(this.$globalUrl + res.payload);
              // });
            },
            add() {
              this.getModal("add").open();
            },
            hang() {
              this.getModal("hang").open();
            },
            cancelHang() {
              let data = {
                ids: this.selectAll.map(item => item.id)
              };
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("cancelHangStatus", data).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("codNAme"),
          key: "name",
          minWidth: 130,
          align: "left"
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          // component: "Button",
          minWidth: 160,
          bind: {
            type: "primary",
            size: "small"
          },
          copy: true,
          methods: {
            render({ row }) {
              return row.airway_bill_number;
            }
          }
        },
        {
          name: () => this.$t("clientName"),
          key: "client",
          minWidth: 100
        },
        {
          name: () => this.$t("codTypes"),
          key: "bill_type",
          minWidth: 80
        },
        {
          name: () => this.$t("exlType"),
          key: "status_name",
          minWidth: 80
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 100
        },
        {
          name: () => this.$t("receivable") + this.$t("Remarks"),
          key: "cw_agent_remarks",
          minWidth: 100
        },
        {
          name: () =>
            this.$t("bill_close_account_issuing_confirm") + this.$t("Remarks"),
          key: "cw_client_remarks",
          minWidth: 100
        },
        {
          name: () => this.$t("original") + this.$t("bill_type"),
          key: "origin_status",
          minWidth: 100
        },
        {
          name: () => this.$t("original") + this.$t("cod_1_time"),
          key: "out_time",
          width: 170
        },
        {
          name: () => this.$t("original") + this.$t("check_time"),
          key: "end_time",
          width: 170
        },
        {
          name: () => this.$t("rate"),
          key: "origin_to_usd_rate",
          minWidth: 100
        },
        {
          name: () =>
            this.$t("original") + this.$t("bill_close_account_issuing"),
          key: "origin_issuing",
          minWidth: 100
        },
        {
          name: () =>
            this.$t("original") + this.$t("bill_close_account_issuing_charge"),
          key: "origin_charge",
          minWidth: 80
        },
        {
          name: () => this.$t("original") + this.$t("accounting_amount"),
          key: "orign_confirm",
          minWidth: 100
        },
        {
          name: () => this.$t("cod_amount"),
          key: "cod_amount",
          minWidth: 100
        },
        {
          name: () => this.$t("currencyCode"),
          key: "cod_amount_currency",
          minWidth: 80
        },
        {
          name: () => this.$t("bill_number"),
          key: "check_bill_number",
          minWidth: 140
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 170
        },
        {
          name: () => this.$t("tracker_code"),
          key: "trace_status",
          minWidth: 80
        },
        {
          name: () => this.$t("tracker_description"),
          key: "status_remarks",
          align: "left",
          minWidth: 110
        },
        // {
        //   name: () => this.$t("tracker_description_cn"),
        //   key: "status_cn",
        //   align: "left",
        //   minWidth: 110
        // },
        {
          name: () => this.$t("status_time"),
          key: "trace_time",
          minWidth: 110
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("trajectory"),
              type: "showStatus",
              fnName: "showStatus"
              // bind: {
              //   type: "success"
              // }
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 424
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 426
            }
          ],
          methods: {
            showStatus({ row }) {
              this.getModal("showStatus").open({ row }, function() {
                this.setTitle(
                  row.airway_bill_number + "(" + this.$t("trajectory") + ")"
                );
              });
            },
            update({ row }) {
              this.getModal("add").open(row, () =>
                this.getModal("add").setTitle(this.$t("update"))
              );
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
